import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Social from "./Social";
import externalUrls from "./externalUrls";
import { ReactComponent as StakeIcon } from "../../assets/icons/stake.svg";
import { ReactComponent as BondIcon } from "../../assets/icons/bond.svg";
import { ReactComponent as CalcIcon } from "../../assets/icons/calculator.svg";
import { ReactComponent as SeedlingIcon } from "../../assets/icons/seedling.svg";
import { ReactComponent as ExchangeIcon } from "../../assets/icons/exchange.svg";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboard.svg";
import { ReactComponent as WrapIcon } from "../../assets/icons/wrap.svg";
import { ReactComponent as HectorIcon } from "../../assets/icons/hector-nav-logo.svg";
import { ReactComponent as InvestmentsIcon } from "../../assets/icons/investments.svg";
import { ReactComponent as TorSVG } from "../../assets/tokens/tor-nav.svg";
import { shorten } from "../../helpers";
import { useAddress } from "src/hooks/web3Context";
import { Paper, Link, Box, Typography, SvgIcon } from "@material-ui/core";
import "./sidebar.scss";
import { HECTOR_ENV } from "../../helpers/Environment";

function NavContent() {
  const [isActive] = useState();
  const address = useAddress();
  const stakingRebase = useSelector(state => {
    return state.app.stakingRebase;
  });

  const checkPage = useCallback((match, location, page) => {
    const currentPath = location.pathname.replace("/", "");
    if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
      return true;
    }
    if (currentPath.indexOf("stake") >= 0 && page === "stake") {
      return true;
    }
    if (currentPath.indexOf("wrap") >= 0 && page === "wrap") {
      return true;
    }
    if (currentPath.indexOf("calculator") >= 0 && page === "calculator") {
      return true;
    }
    if (currentPath.indexOf("farming") >= 0 && page === "farming") {
      return true;
    }
    if (currentPath.indexOf("mint") >= 0 && page === "mint") {
      return true;
    }
    if (currentPath.indexOf("exchange") >= 0 && page === "exchange") {
      return true;
    }
    if ((currentPath.indexOf("bonds") >= 0 || currentPath.indexOf("choose_bond") >= 0) && page === "bonds") {
      return true;
    }
    return false;
  }, []);

  return (
    <Paper className="dapp-sidebar">
      <Box className="dapp-sidebar-inner" display="flex" justifyContent="space-between" flexDirection="column">
        <div className="dapp-menu-top">
          <Box className="branding-header">
            <Link href="https://app.hector.finance" target="_blank">
              <SvgIcon
                id="header-nav-logo"
                color="primary"
                viewBox="0 0 151 100"
                component={HectorIcon}
                style={{ minWdth: "151px", minHeight: "98px", width: "151px" }}
              />
              <div className="wallet-link f-32">Hector</div>
            </Link>
            {address && (
              <div className="wallet-link">
                <Link href={`https://ftmscan.com/address/${address}`} target="_blank">
                  {shorten(address)}
                </Link>
              </div>
            )}
          </Box>

          <div className="dapp-menu-links">
            <div className="dapp-nav" id="navbarNav">
              <Link
                component={NavLink}
                id="dash-nav"
                to="/dashboard"
                isActive={(match, location) => {
                  return checkPage(match, location, "dashboard");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={DashboardIcon} />
                  Dashboard
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="stake-nav"
                to="/"
                isActive={(match, location) => {
                  return checkPage(match, location, "stake");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <StakeIcon />
                  Stake
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="wrap-nav"
                to="/wrap"
                isActive={(match, location) => {
                  return checkPage(match, location, "wrap");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <WrapIcon />
                  Wrap
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="bond-nav"
                to="/bonds"
                isActive={(match, location) => {
                  return checkPage(match, location, "bonds");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SvgIcon color="primary" component={BondIcon} />
                  Bond
                </Typography>
              </Link>
              <Link
                component={NavLink}
                id="exchange-nav"
                to="/exchange"
                onClick={event => {
                  if (HECTOR_ENV === "prod") {
                    event.preventDefault();
                  }
                }}
                isActive={(match, location) => {
                  return checkPage(match, location, "exchange");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <ExchangeIcon />
                  Exchange
                  <Typography variant="caption" style={{ marginLeft: "8px" }}>
                    (Coming Soon)
                  </Typography>
                </Typography>
              </Link>
              <Link
                component={NavLink}
                id="farm-nav"
                to="/farming"
                onClick={event => {
                  if (false) {
                    event.preventDefault();
                  }
                }}
                isActive={(match, location) => {
                  return checkPage(match, location, "farming");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <SeedlingIcon />
                  Farm
                </Typography>
              </Link>
              <Link
                component={NavLink}
                id="mint"
                to="/mint"
                onClick={event => {
                  if (false) {
                    event.preventDefault();
                  }
                }}
                isActive={(match, location) => {
                  return checkPage(match, location, "mint");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <TorSVG />
                  TOR Mint
                </Typography>
              </Link>
              <Link
                component={NavLink}
                id="investments-nav"
                to="/investments"
                onClick={event => {
                  if (HECTOR_ENV === "prod") {
                    event.preventDefault();
                  }
                }}
                isActive={(match, location) => {
                  return checkPage(match, location, "investments");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <InvestmentsIcon />
                  Investments
                  <Typography variant="caption" style={{ marginLeft: "8px" }}>
                    (Coming Soon)
                  </Typography>
                </Typography>
              </Link>

              <Link
                component={NavLink}
                id="calc-nav"
                to="/calculator"
                isActive={(match, location) => {
                  return checkPage(match, location, "calculator");
                }}
                className={`button-dapp-menu ${isActive ? "active" : ""}`}
              >
                <Typography variant="h6">
                  <CalcIcon />
                  Calculator
                </Typography>
              </Link>
            </div>
          </div>
        </div>
        <hr style={{ width: "80%", marginBottom: "25px", marginTop: "25px" }} />
        <Box className="dapp-menu-bottom" display="flex" justifyContent="space-between" flexDirection="column">
          <div className="dapp-menu-external-links">
            {externalUrls.map(({ url, icon, title, label }, i) => {
              return (
                <Link key={i} href={url} target="_blank" component={url ? "a" : "span"}>
                  <Typography variant="h6">{icon}</Typography>
                  <Typography variant="h6">{title}</Typography>
                  {label ? (
                    <Typography variant="caption" style={{ marginLeft: "8px" }}>
                      {label}
                    </Typography>
                  ) : null}
                </Link>
              );
            })}
          </div>
          <div className="dapp-menu-social">
            <Social />
          </div>
        </Box>
      </Box>
    </Paper>
  );
}

export default NavContent;
